import Stack from "@mui/material/Stack/Stack";
import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import { Button, TextField, Typography } from "@mui/material";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { Container } from "@mui/system";
import DrawerAppBar from "../../../../../components/mobile/Navbar";
import { useSelector } from "react-redux";
import { StoreState } from "../../store";
import { ReceiptCheckItem } from "../../../../../../domain/models/receipt-check";
import { useNavigate } from "react-router-dom";

export const StoreCollector: React.FC = () => {
  const [code, setCode] = useState<string>("");
  const [batch, setBatch] = useState<string>("");
  const item = useSelector<StoreState, ReceiptCheckItem | null>(
    (state) => state.currentItem
  );
  const navigate = useNavigate();

  const handleClick = () => {
    if (!code) return alert("Preencha o código antes de continuar");
    if (item?.batchControl && !batch)
      return alert("Preencha o lote antes de continuar");
    if (code !== item?.code) return alert("Código incorreto");
    if (
      item?.batchControl &&
      batch.trim().toUpperCase().split(" ").join("") !==
        item?.batch?.trim().toUpperCase().split(" ").join("")
    ) {
      return alert("Lote incorreto");
    }
    navigate("/mobile/store/positionCollector");
  };

  return (
    <>
      <DrawerAppBar
        title="Coletar dados do produto"
        onBack={() => {
          navigate("/mobile/store/");
        }}
      />
      <Stack sx={{ m: "20px" }} spacing={4}>
        <Paper>
          <Stack spacing={4} sx={{ mx: "10px", my: "30px" }}>
            <Stack direction="row">
              <TextField
                id="outlined-basic"
                label="Código do Produto"
                variant="outlined"
                sx={{
                  mx: "5px",
                }}
                value={code}
                onChange={(e) => {
                  setCode(e.target.value);
                }}
              />
              <Button
                variant="outlined"
                color="inherit"
                sx={{
                  mx: "5px",
                }}
              >
                <QrCodeIcon />
              </Button>
            </Stack>
            <Container
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* <Typography
                fontWeight="bold"
                sx={{ textDecoration: "underline" }}
              >
                Não consegue ler o código? Clique aqui.
              </Typography> */}
            </Container>
            {item?.batchControl && (
              <Container>
                <TextField
                  id="outlined-basic"
                  label="Lote"
                  variant="outlined"
                  sx={{
                    mx: "5px",
                  }}
                  value={batch}
                  onChange={(e) => {
                    setBatch(e.target.value);
                  }}
                />
              </Container>
            )}

            {/* <Stack>
              <FormControl sx={{ mx: "20px", marginBottom: "20px" }}>
                <FormLabel
                  id="demo-radio-buttons-group-label"
                  sx={{ fontWeight: "bold" }}
                >
                  Modo de Seleção de Posições
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="automatic"
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="automatic"
                    control={<Radio />}
                    label="Seleção Feita pelo Domus"
                  />
                  <FormControlLabel
                    value="manual"
                    control={<Radio />}
                    label="Seleção Manual de Posição"
                  />
                </RadioGroup>
              </FormControl>
            </Stack> */}
          </Stack>
        </Paper>

        <Button
          variant="contained"
          color="secondary"
          sx={{ color: "white", height: "50px", fontWeight: "bold" }}
          onClick={handleClick}
        >
          Continuar
        </Button>
      </Stack>
    </>
  );
};
